import type { ReactNode } from 'react';

interface PanelProps {
  title: string;
  wide?: boolean;
  mobilePriority?: number;
  children: ReactNode;
  headerAction?: ReactNode;
  className?: string;
}

function slugify(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function Panel({ title, wide, mobilePriority, children, headerAction, className }: PanelProps) {
  return (
    <div
      data-testid={`ops-panel-${slugify(title)}`}
      className={`bg-slate-900/60 backdrop-blur-sm border border-slate-800 rounded-2xl p-4 ${wide ? 'md:col-span-2' : ''} ${className || ''}`}
      data-priority={mobilePriority}
    >
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-400">
          {title}
        </h2>
        {headerAction}
      </div>
      {children}
    </div>
  );
}
